import { defineComponent } from "vue"
import { Icon, Step, Steps } from "vant"
import styles from "./index.module.less"

export default defineComponent({
  name: "HeadSteps",
  props: {
    data: {
      type: Array,
      required: true
    },
    active: {
      type: Number
    }
  },
  emits: ["update:active"],
  setup(props, { emit }) {
    const renderStep = () => {
      return props.data.map((item) => {
        const slot = {
          default: () => {
            return <div class={styles.stepText}>{item.name}</div>
          },
          "finish-icon": () => {
            return (
              <span class={styles.stepFinish}>
                <Icon name="success" color="#fff"></Icon>
              </span>
            )
          },
          "active-icon": () => {
            return <span class={styles.stepActive}></span>
          },
          "inactive-icon": () => {
            return <span class={styles.stepInactive}></span>
          }
        }
        return <Step vSlots={slot} class={styles.step}></Step>
      })
    }

    const clickStep = (index) => {
      if (index < props.active) emit("update:active", index)
    }

    return () => {
      return (
        <Steps
          class={styles.steps}
          active={props.active}
          onClickStep={clickStep}
        >
          {renderStep()}
        </Steps>
      )
    }
  }
})
